// extracted by mini-css-extract-plugin
export default {"Header":"Intro_Header__4tWdU","Text":"Intro_Text__XIgiN"};